var _g, _g2, _g3, _g4, _path, _path2, _g5, _g6, _g7, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWastageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "food-waste",
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9507",
    "data-name": "Group 9507",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9506",
    "data-name": "Group 9506",
    transform: "translate(11.283)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11203",
    "data-name": "Path 11203",
    d: "M108.1,0A32.842,32.842,0,0,0,87.247,7.284a2.383,2.383,0,0,0-.392.686,37.788,37.788,0,0,0-.97,7.388c0,18.5,15.6,33.5,34.1,33.5,7.124,0,15.051-3.415,20.356-7.52a5.5,5.5,0,0,0,.5-.709A32.786,32.786,0,0,0,141.6,33.5,33.5,33.5,0,0,0,108.1,0Z",
    transform: "translate(-85.885)",
    fill: "#d4f2f6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11204",
    "data-name": "Path 11204",
    d: "M45.384,96.07A33.521,33.521,0,0,1,12.645,55.445a33.5,33.5,0,0,0,.691,52.97l40.481-.119a33.458,33.458,0,0,0,12.422-19.51A33.356,33.356,0,0,1,45.384,96.07Z",
    transform: "translate(0 -48.161)",
    fill: "#cce1fe"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9508",
    "data-name": "Group 9508",
    transform: "translate(13.756 18.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11205",
    "data-name": "Path 11205",
    d: "M109.634,140.987l5.148,12.694H104.71Z",
    transform: "translate(-104.71 -140.987)",
    fill: "#ffd15b"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9516",
    "data-name": "Group 9516",
    transform: "translate(9.048 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9510",
    "data-name": "Group 9510",
    transform: "translate(2.434 2.624)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9509",
    "data-name": "Group 9509",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11206",
    "data-name": "Path 11206",
    d: "M0,0H3.635V18.262H0Z",
    transform: "matrix(0.59, -0.808, 0.808, 0.59, 0, 2.937)",
    fill: "#f7f3f1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9511",
    "data-name": "Group 9511",
    transform: "translate(10.994 8.666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11207",
    "data-name": "Path 11207",
    d: "M157.919,66.612a3.37,3.37,0,1,0-3.976,5.443,6.334,6.334,0,0,1,2.575,4.751,12.431,12.431,0,0,0,5.257,9.1C167,89.724,173.865,89.229,177.1,84.8s1.622-11.118-3.607-14.937a12.431,12.431,0,0,0-10.267-2.24,6.335,6.335,0,0,1-5.309-1.008Z",
    transform: "translate(-152.56 -65.963)",
    fill: "#a37544"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9513",
    "data-name": "Group 9513",
    transform: "translate(14.983 15.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9512",
    "data-name": "Group 9512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11208",
    "data-name": "Path 11208",
    d: "M201.13,123.481c-3.236,4.431-10.1,4.926-15.327,1.107a13.594,13.594,0,0,1-2.881-2.841,12.514,12.514,0,0,0,5.226,8.716c5.228,3.819,12.09,3.323,15.327-1.107,2.534-3.469,2.094-8.32-.725-12.1A8.952,8.952,0,0,1,201.13,123.481Z",
    transform: "translate(-182.922 -117.26)",
    fill: "#936338"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9514",
    "data-name": "Group 9514",
    transform: "translate(0 3.73)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_141",
    "data-name": "Ellipse 141",
    cx: 2.498,
    cy: 2.498,
    rx: 2.498,
    ry: 2.498,
    fill: "#f7f3f1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9515",
    "data-name": "Group 9515",
    transform: "translate(2.725)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_142",
    "data-name": "Ellipse 142",
    cx: 2.498,
    cy: 2.498,
    rx: 2.498,
    ry: 2.498,
    fill: "#f7f3f1"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9520",
    "data-name": "Group 9520",
    transform: "translate(34.635 13.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9517",
    "data-name": "Group 9517",
    transform: "translate(0 2.463)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_143",
    "data-name": "Ellipse 143",
    cx: 6.564,
    cy: 8.281,
    rx: 6.564,
    ry: 8.281,
    transform: "translate(0 3.584) rotate(-15.843)",
    fill: "#fe5694"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9518",
    "data-name": "Group 9518",
    transform: "translate(10.846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11209",
    "data-name": "Path 11209",
    d: "M347.327,109.3a1.127,1.127,0,0,1-1.119-1.264l.72-5.816a1.126,1.126,0,0,1,2.235.277l-.72,5.816A1.126,1.126,0,0,1,347.327,109.3Z",
    transform: "translate(-346.2 -101.227)",
    fill: "#936338"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9519",
    "data-name": "Group 9519",
    transform: "translate(8.966 4.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11210",
    "data-name": "Path 11210",
    d: "M343.785,137.2a2.085,2.085,0,0,1-2.862-2.683,2.116,2.116,0,0,1-1.052-2.217c-3.2-.277-6.459,2.369-7.589,6.359-1.246,4.4.571,8.768,4.059,9.756s7.326-1.778,8.572-6.179a10.1,10.1,0,0,0,.372-3.372A1.939,1.939,0,0,1,343.785,137.2Z",
    transform: "translate(-331.89 -132.285)",
    fill: "#f07281"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11211",
    "data-name": "Path 11211",
    d: "M70.3,229.534l4.1,30.1a33.463,33.463,0,0,0,7.426,4.239l2.536-.75,1.6,2.14a33.427,33.427,0,0,0,6.542,1.053l2.065-1.8,2.065,1.8a33.407,33.407,0,0,0,6.542-1.056l2.065-1.894,2.065.5a33.53,33.53,0,0,0,7.579-4.353l3.948-29.981H70.3Z",
    transform: "translate(-61.064 -199.379)",
    fill: "#0ed290"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11212",
    "data-name": "Path 11212",
    d: "M80.6,239.836h36.871l1.357-10.3H70.3l4.1,30.1a33.462,33.462,0,0,0,7.426,4.239l1.97-.582Z",
    transform: "translate(-61.064 -199.379)",
    fill: "#0ab69f"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9521",
    "data-name": "Group 9521",
    transform: "translate(6.581 29.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11213",
    "data-name": "Path 11213",
    d: "M50.091,222.534H103.93v7.709H50.091Z",
    transform: "translate(-50.091 -222.534)",
    fill: "#97da7b"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9522",
    "data-name": "Group 9522",
    transform: "translate(20.762 43.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11214",
    "data-name": "Path 11214",
    d: "M241.344,357.473q1.04,0,2.065-.063V336.47a2.065,2.065,0,1,0-4.131,0v20.94Q240.3,357.473,241.344,357.473Z",
    transform: "translate(-228.607 -334.405)",
    fill: "#0ab69f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11215",
    "data-name": "Path 11215",
    d: "M160.107,334.405a2.065,2.065,0,0,0-2.065,2.065v18.5a33.241,33.241,0,0,0,4.131,1.391V336.47a2.065,2.065,0,0,0-2.065-2.065Z",
    transform: "translate(-158.042 -334.405)",
    fill: "#0996a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11216",
    "data-name": "Path 11216",
    d: "M324.647,354.962V336.47a2.065,2.065,0,1,0-4.131,0v19.884A33.3,33.3,0,0,0,324.647,354.962Z",
    transform: "translate(-299.171 -334.405)",
    fill: "#0ab69f"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9523",
    "data-name": "Group 9523",
    transform: "translate(8.83 18.521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11217",
    "data-name": "Path 11217",
    d: "M74.844,155.552a45.521,45.521,0,0,0,.836,9.749,36.73,36.73,0,0,0,1.383,4.819,13.694,13.694,0,0,1-4.65-2.836,15.836,15.836,0,0,1,0-23.463,13.7,13.7,0,0,1,4.65-2.836A36.677,36.677,0,0,0,75.68,145.8,45.515,45.515,0,0,0,74.844,155.552Z",
    transform: "translate(-67.213 -140.984)",
    fill: "#fee45a"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9525",
    "data-name": "Group 9525",
    transform: "translate(17.145 14.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9524",
    "data-name": "Group 9524"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11218",
    "data-name": "Path 11218",
    d: "M132.664,117.862l-2.157-.872,1.244-4.392,3.069,1.225Z",
    transform: "translate(-130.507 -112.598)",
    fill: "#755431"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWastageIcon);
export default __webpack_public_path__ + "static/media/wastage-icon.859c1bddb7455fa62caf46de760eb6be.svg";
export { ForwardRef as ReactComponent };